import React from "react";
import { Users, GraduationCap, Globe, BrainCircuit } from "lucide-react";
import { pillars } from "../mock";
import useReveal from "../hooks/useReveal";

const icons = { Users, GraduationCap, Globe, BrainCircuit };

export default function Features() {
  const ref = useReveal();
  return (
    <section ref={ref} className="bg-white py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((p, i) => {
            const Icon = icons[p.icon];
            return (
              <div
                key={p.title}
                className="cc-reveal group"
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-[110px] h-[110px] rounded-full flex items-center justify-center bg-[#eaf3ff] border-[3px] border-[#2b8cf0] text-[#2b8cf0] mb-6 transition-all duration-300 group-hover:bg-[#2b8cf0] group-hover:text-white group-hover:-translate-y-1">
                    <Icon size={48} strokeWidth={1.6} />
                  </div>
                  <h3 className="font-head text-xl font-semibold text-[#16244F] mb-3">{p.title}</h3>
                  <p className="text-[15px] leading-relaxed text-[#5a6274]">{p.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
